
<template>
  <!-- <ul>
    <li v-for="locale in locales" :key="locale" @click="switchLocale(locale)">
      {{locale}}
    </li>
  </ul> -->
  <v-select
    v-model="locale"
    :items="locales"
    :label="label"
    class="my-0 py-0"
    @change="switchLocale()"
  >
    <template v-slot:selection="{ item }">
      {{ $t("language." + item + ".text") }}
    </template>
    <template v-slot:item="{ item }">
      {{ $t("language." + item + ".text") }}
    </template>  
  </v-select>
</template>
<script>
export default {
  name: 'locale-changer',
  data() {
    return {
      locale: this.$i18n.locale,
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
    }
  },
  computed: {
    label(item) {
      return this.$t("language." + item.locale + ".label");
    }
  },
  methods: { // <---------------------------
    switchLocale() {
      if (this.$i18n.locale !== this.locale) {
        this.$i18n.locale = this.locale;
        window.document.cookie = "locale=" + this.locale;
      }
    },
  },
}
</script>